// import Vue from 'vue'
// import axios from 'axios'
// import VueAxios from 'vue-axios'
// Vue.use(axios)
// Vue.use(VueAxios)
import axios from '@/plugins/axios'

export default {
  install(Vue) {
    Vue.prototype.$seriesApiService = {
      series_api_url: `${process.env.VUE_APP_AUDIOVISUAL_API_URL}/series`,

      /**
       * 查詢
       * @param {string} param - API 查詢參數
       * @returns {Promise<Object>} API 回傳的資料結構
       */
      async query(param = '') {
        const url = `${this.series_api_url}`
        const params = param ? `?${param}` : ''
        const response = await axios.get(`${url}${params}`)
        return response.data
      },

      /**
       * 根據分類查詢
       * @param {string} category_no - 分類編號
       * @param {string} additional - 額外的 API 查詢參數
       * @returns {Promise<Object>} API 回傳的資料結構
       */
      async queryByCategoryNo(category_no, additional = '') {
        const url = `${this.series_api_url}?filter[of_category]=${category_no}`
        const additional_params = additional ? `&${additional}` : ''
        const response = await axios.get(`${url}${additional_params}`)
        return response.data
      },

      /**
       * 根據關鍵字查詢
       * @param {string} keyword - 關鍵字
       * @param {string} additional - 額外的 API 查詢參數
       * @returns {Promise<Object>} API 回傳的資料結構
       */
      async queryByKeyword(keyword, additional = '') {
        const url = `${this.series_api_url}/by-keyword-searched?filter[keyword]=${keyword}`
        const additional_params = additional ? `&${additional}` : ''
        const response = await axios.get(`${url}${additional_params}`)
        return response.data
      },

      /**
       * 取得最新加入的影音系列
       * @param {number} quantity - 數量
       * @param {string} additional - 額外的 API 查詢參數
       * @returns {Promise<Object>} API 回傳的資料結構
       */
      async getRecentlyAdded(quantity = 20, additional = '') {
        const url = `${this.series_api_url}/recently-added?limit=${quantity}`
        const additional_params = additional ? `&${additional}` : ''
        const response = await axios.get(`${url}${additional_params}`)
        return response.data
      },

      /**
       * 取得有更新單集的影音系列
       * @param {number} quantity - 數量
       * @param {string} additional - 額外的 API 查詢參數
       * @returns {Promise<Object>} API 回傳的資料結構
       */
      async getWithEpisodesUpdated(quantity = 30, additional = '') {
        const url = `${this.series_api_url}/with-episodes-updated?limit=${quantity}`
        const additional_params = additional ? `&${additional}` : ''
        const response = await axios.get(`${url}${additional_params}`)
        return response.data
      },

      /**
       * 取得持續更新的影音系列
       * @param {string} additional - 額外的 API 查詢參數
       * @returns {Promise<Object>} API 回傳的資料結構
       */
      async getOngoing(additional = '') {
        const url = `${this.series_api_url}?filter[ended]=N`
        const additional_params = additional ? `&${additional}` : ''
        const response = await axios.get(`${url}${additional_params}`)
        return response.data
      },

      /**
       * 根據編號取得
       * @param {string} series_no - 編號
       * @param {string} default_value - 預設值
       * @returns {Promise<Object>} API 回傳的資料結構
       */
      async getBySeriesNo(series_no, default_value = null) {
        const response = await axios.get(`${this.series_api_url}/${series_no}`);

        return response.data.data && Object.keys(response.data.data).length > 0
          ? response.data
          : default_value
      },

      /**
       * 取得影音集數
       * @param {string} series - 系列
       * @param {string} additional - 額外的 API 查詢參數
       * @returns {Promise<Object>} API 回傳的資料結構
       */
      async fetchEpisodes(series, additional = '') {
        const url = `${this.series_api_url}/${series.title_no}/episodes`
        const additional_params = additional ? `?${additional}` : ''
        const response = await axios.get(`${url}${additional_params}`)
        return response.data
      }
    }
  }
}
